<template>
  <transition name="page" mode="out-in">
    <slot>
      <nuxt></nuxt>
    </slot>
  </transition>
</template>

<script>
export default {
  name: 'CoreView',
  metaInfo() {
    return {
      title: 'SiTrendi by Nash Technology from PT Nash Interaksi Semesta',
    }
  },
}
</script>
